export const SET_ITEM_TASKS = 'SET_ITEM_TASKS';
export const SET_ITEM_LOADING = 'SET_ITEM_LOADING';
export const SET_ITEM_DETAILS = 'SET_ITEM_DETAILS';
export const SET_WORK_PROCESSES = 'SET_WORK_PROCESSES'
export const SET_WORK_PROCESSES_AVAILABLE = 'SET_WORK_PROCESSES_AVAILABLE'
export const ADD_WORK_PROCESS = 'ADD_WORK_PROCESS'
export const UPDATE_WORK_PROCESS = 'UPDATE_WORK_PROCESS'
export const DELETE_WORK_PROCESS = 'DELETE_WORK_PROCESS'
export const SET_TASKS = 'SET_TASKS'
export const SET_LOADING = 'SET_LOADING'
export const SET_ERROR = 'SET_ERROR'
export const SET_VEHICLE_MODELS = 'SET_VEHICLE_MODELS'
export const SET_USERS = 'SET_USERS'
export const ADD_TASK = 'ADD_TASK'
export const UPDATE_TASK = 'UPDATE_TASK'
export const DELETE_TASK = 'DELETE_TASK'
export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE'
